import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import UserControls from 'flarum/forum/utils/UserControls';
export default function addSpamblockControls() {
  extend(UserControls, 'moderationControls', function (items, user) {
    user.canSpamblock() && items.add('spammer', m(Button, {
      icon: "fas fa-pastafarianism",
      onclick: () => {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/HandleSpammerModal', webpackMode: 'lazy-once' */ '../components/HandleSpammerModal'), {
          user
        });
      }
    }, app.translator.trans('fof-anti-spam.forum.user_controls.spammer_button')));
  });
}
flarum.reg.add('fof-anti-spam', 'forum/extenders/addSpamblockControls', addSpamblockControls);flarum.reg.addChunkModule('386', '571', 'fof-anti-spam', 'forum/components/HandleSpammerModal');